module.exports = __webpack_public_path__ + "img/6.14c19808.jpg";